import React, { type FunctionComponent, useEffect } from 'react'
import styled from '@emotion/styled'
import { spacing } from '@retailer-platform/shared-components'
import { useDomainMessages } from 'domains/products/utils/domain/intl'
import { ErrorPage } from 'gin-and-tonic/containers/error-page/ErrorPage'
import {
  RetailerLocaleSelect,
  type OnLocaleChangeCallback,
} from 'gin-and-tonic/containers/locale-select/LocaleSelect'
import { trackEvent } from 'utils/events/trackEvent'

const StyledErrorPage = styled(ErrorPage)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',

  p: {
    marginBottom: spacing.X20,
  },

  '.locale-selector': {
    width: 100,
    paddingBottom: spacing.X20,
    margin: '0 auto',
  },
})

interface Props {
  locale: string
  onLocaleChange: OnLocaleChangeCallback
  productId: string
}

export const ProductsViewNotFoundErrorPage: FunctionComponent<Props> = ({
  onLocaleChange,
  locale,
  productId,
}) => {
  const messages = useDomainMessages({
    body: 'productsDomain.view.errors.notFound.body',
    after: 'productsDomain.view.errors.notFound.afterAction',
  })

  useEffect(() => {
    trackEvent({
      id: 'products.product_details.not_found_i18n',
      description:
        'Attempted to obtain a product for which we do not have a translation for a specific locale.',
      data: { locale, productId },
    })
  }, [locale, productId])

  return (
    <StyledErrorPage data-testid="products-view-not-found-error-page">
      <p>{messages.body}</p>

      <div className="locale-selector">
        <RetailerLocaleSelect onChange={onLocaleChange} initialValue={locale} />
      </div>

      <p>{messages.after}</p>
    </StyledErrorPage>
  )
}
